/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { MerkleOrderbookFactory__factory } from './MerkleOrderbookFactory__factory';
